// src/components/InsightButton.js
// Tasto "Nexiora Insight" negli header delle sezioni. Ottobre 2026: Insight contiene dati
// economici di tutta l'azienda ed è riservato a titolare e admin (come la pagina e la barra
// laterale): per gli altri il tasto non compare. Prima si accendeva anche per chi era
// abilitato da Abilitazioni, che poi trovava la pagina chiusa.
import React from "react";
import { useAuth } from "../contexts/AuthContext";

export default function InsightButton({ onNavigate, style = {} }) {
  const { isOrgAdmin, isPlatformOwner } = useAuth();
  if (!isPlatformOwner && !isOrgAdmin) return null;
  return (
    <button
      onClick={() => onNavigate && onNavigate({ page: "nexiora-insight" })}
      style={{
        display: "flex", alignItems: "center", gap: 5,
        padding: "4px 12px",
        background: "#fff",
        border: "1px solid #ddd6fe", borderRadius: 8,
        color: "#6d28d9", fontSize: 12, fontWeight: 700,
        cursor: "pointer", fontFamily: "'Inter',sans-serif",
        whiteSpace: "nowrap",
        ...style,
      }}
      title="Vai a Nexiora Insight"
    >
      📊 Nexiora Insight
    </button>
  );
}
